export default __webpack_public_path__ + "media/images/features/ana/balloon2-3913283fc4a0fa5119e1b5c0c0f72af0.png";